__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "login";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.99.2", () => (__webpack_require__.e(8736).then(() => (() => (__webpack_require__(8736))))));
			register("axios", "1.6.8", () => (__webpack_require__.e(3254).then(() => (() => (__webpack_require__(3254))))));
			register("dompurify", "3.3.1", () => (__webpack_require__.e(9944).then(() => (() => (__webpack_require__(9944))))));
			register("i18next", "25.2.1", () => (__webpack_require__.e(8683).then(() => (() => (__webpack_require__(8683))))));
			register("next/compat/router", "15.5.12", () => (() => (__webpack_require__(2156))), 1);
			register("next/dynamic", "15.5.12", () => (__webpack_require__.e(2843).then(() => (() => (__webpack_require__(2843))))));
			register("next/head", "15.5.12", () => (() => (__webpack_require__(8716))), 1);
			register("next/image", "15.5.12", () => (__webpack_require__.e(996).then(() => (() => (__webpack_require__(8615))))));
			register("next/link", "15.5.12", () => (() => (__webpack_require__(3570))), 1);
			register("next/router", "15.5.12", () => (() => (__webpack_require__(3063))), 1);
			register("next/script", "15.5.12", () => (__webpack_require__.e(3621).then(() => (() => (__webpack_require__(3621))))));
			register("react-dom", "19.1.0", () => (() => (__webpack_require__(4518))), 1);
			register("react-hook-form", "7.73.1", () => (__webpack_require__.e(240).then(() => (() => (__webpack_require__(240))))));
			register("react-i18next", "15.5.3", () => (__webpack_require__.e(3553).then(() => (() => (__webpack_require__(3553))))));
			register("react-lazily", "0.9.2", () => (__webpack_require__.e(1178).then(() => (() => (__webpack_require__(1178))))));
			register("react-phone-number-input", "0", () => (__webpack_require__.e(6321).then(() => (() => (__webpack_require__(6321))))));
			register("react-tooltip", "5.30.0", () => (Promise.all([__webpack_require__.e(4937), __webpack_require__.e(6936)]).then(() => (() => (__webpack_require__(4937))))));
			register("stores/use-toast-store", "1.0.0", () => (() => (__webpack_require__(6014))), 1);
			register("zustand", "4.5.7", () => (() => (__webpack_require__(9971))), 1);
			register("react-dom/client", "19.1.0", () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(2181))))));
			register("react/jsx-runtime", "19.1.0", () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(4489))))));
			register("react", "19.1.0", () => (__webpack_require__.e(6593).then(() => (() => (__webpack_require__(4349))))));
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(7674).then(() => (() => (__webpack_require__(7674))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(8615).then(() => (() => (__webpack_require__(996))))));
			initExternal(1305);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};